import styled from 'styled-components';

export const SearchBarContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const SearchBarLabel = styled.label`
  font-size: 16px;
  color: #333;
  margin-right: 10px;
`;

export const SearchBarSelect = styled.select`
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background-color: #fafafa;
  margin-left: 10px;
  margin-bottom: 10px;

  &:focus {
    outline: none;
    border-color: #999;
  }

  &:hover {
    background-color: #eee;
  }
`;

export const SearchBarInput = styled.input`
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background-color: #fafafa;
  margin-left: 10px;
  margin-bottom: 10px;

  &:focus {
    outline: none;
    border-color: #999;
  }

  &:hover {
    background-color: #eee;
  }
`;

export const FilterButton = styled.button`
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #007bff;
  background-color: #007bff;
  color: #fff;
  margin-left: 10px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
    border-color: #0056b3;
  }

  &:focus {
    outline: none;
  }
`;
